import { html } from "lit-html";
import { getFooterTranslation } from "./helpers/WhiteLabelTranslationHelper";
export const footerTextTemplate = () => html` <div class="text-sm text-center m-auto max-w-screen-xl">&copy; ${(/* @__PURE__ */ new Date()).getFullYear()} ${getFooterTranslation()}</div> `;
